import styled from 'styled-components';
import {personAvatarUrl} from "@betrue/front/services";
import {Avatar} from "@mui/material";
import {Person} from "@betrue/shared/interfaces";

/* eslint-disable-next-line */
export interface BtAvatarProps {
  person:Person
}

const StyledBtAvatar = styled.div`
  color: pink;
`;

export function BtAvatar(props: BtAvatarProps) {
  return (
    <Avatar aria-label="recipe" className={'avatar'} src={personAvatarUrl((props.person))}>
      {
        props.person.firstName && props.person.lastName ?
          props.person.firstName[0] + props.person.lastName[0] :
          '??'
      }
    </Avatar>
  );
}

export default BtAvatar;
